import { render, staticRenderFns } from "./product-returns.vue?vue&type=template&id=7b68e786&"
import script from "./product-returns.vue?vue&type=script&lang=js&"
export * from "./product-returns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports